// src/ModalManager.js
// Handles modal dialog logic for product detail
import ko from 'knockout';

class ModalManager {
    constructor() {
        this.modalVisible = ko.observable(false);
        this.modalHtml = ko.observable("");
    }

    /**
     * Show modal with HTML content
     * 
     * Note: HTML is expected to be safe because it comes from trusted sources:
     * 1. Firestore data (availableInfo, creditsInfo) - stored safely in database
     * 2. ErrorHandler - builds clean HTML with user text already escaped
     * 
     * @param {string} html - HTML content (rendered as-is)
     */
    showModal(html) {
        this.modalHtml(html);
        this.modalVisible(true);
    }

    closeModal() {
        this.modalVisible(false);
        this.modalHtml("");
    }
}

export default ModalManager;
